<image-cropper [imageChangedEvent]="imageChangedEvent" (imageCropped)="imageCropped($event)"
    [maintainAspectRatio]="maintainAspectRatio" [cropperMinWidth]="cropperMinWidth"
    [cropperMinHeight]="cropperMinHeight" [zoomable]="true" [transform]="transform"></image-cropper>